export const displayAsOptions:Array<any> = [
    { value: 'link', text: 'Link' },
    { value: 'image', text: 'Image' }
];

export const itemFloatOptions:Array<any> = [
    { value: 'none', text: 'None'},
    { value: 'left', text: 'Left'},
    { value: 'right', text: 'Right'}
];